module.exports = "<div class=\"msg-data\"><p class=\"msg-text\">{{ data }}</p></div>";